<template>
   <el-dialog
    :title="title"
    :visible.sync="addFaceDialog"
    :before-close="handleClose"
    width="600px"
    >
      <el-form :model="faceObj" :rules="rules" ref="ruleForm" label-width="80px">

        <el-form-item label="" class="login-mid-mid" prop="faceBase">
          <!--捕获人脸区域-->
          <div class="savevideoCamera-canvasCamera ">
            <video
                id="videoCamera2"
                :width="videoWidth"
                :height="videoHeight"
                autoplay
            ></video>
            <canvas
                style="display: none"
                id="canvasCamera2"
                :width="videoWidth"
                :height="videoHeight"
            ></canvas>

            <!--人脸特效区域-->
            <div v-if="faceImgState" class="saveface-special-effects-2"></div>
            <div v-else class="saveface-special-effects"></div>
            <el-input type="hidden" v-model="faceObj.faceBase"></el-input>
          </div>

          <!--拍照显示区域-->
          <div class="savefaceBase" id="faceBase">

          </div>

          <!--按钮区域-->
          <div class="saveface-btn" v-if="cameraState">
            <el-button @click="enteringFace">{{recogText}}</el-button>
          </div>
          <div class="saveface-btn" v-else>
            <el-button >摄像头正在加载...</el-button>
          </div>

        </el-form-item>

        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="submitForm">{{ type===1?'确定录入':'确定' }}</el-button>
        </el-form-item>


      </el-form>

    </el-dialog>
</template>
<script>
import $camera from "../profile/components/camera/index.js";
import {Dialog,Form,FormItem,Button,Input, Message} from 'element-ui'
import axios from 'axios'

export default {
   name: '',
   components: {
     'el-dialog': Dialog,
     'el-form': Form,
     'el-form-item': FormItem,
     'el-button': Button,
     'el-input': Input,
   },
   mixins: [],
   props: {
     type:{
        type: Number,
        default: () => 1, // 1录入人脸 2对比
     }
   },
   data() {
     return {
        videoWidth: 200,
        videoHeight: 200,
        faceImgState:false,
       addFaceDialog: true,
       faceObj:{
        faceBase:'',
      },
      rules:{
        faceBase:[
          { required: true, message: '人脸数据不能为空'}
        ]
      },
      faceOption:{},
      cameraState:false
     }
   },
   computed: {
     title(){
        return Number(this.type) === 1?'人脸录入':'人脸识别'
     },
     recogText(){
        let val;
        if(this.type === 1){
            if(this.faceObj.faceBase===''){
                val='录入人脸'
            }else{
                val='重新录入'
            }
        }else{
            if(this.faceObj.faceBase===''){
                val='识别人脸'
            }else{
                val='重新识别'
            }
        }
        return val;
     }
   },
   watch: {
     
   },
   beforeDestroy(){
    // let faceBase = document.getElementById("faceBase");
    // faceBase.innerHTML = ''
    if(this.faceOption.thisVideo != null){
    // 不等于null 关闭摄像头
    this.faceOption.thisVideo.srcObject.getTracks()[0].stop();
    }
   },
   mounted() {
    setTimeout(() => {this.startVideoFunc()},1000)
     this.setCameraState()
   },
   methods: {
    submitForm() {
        console.log(this.faceObj, 'this.faceObj')
        this.$refs.ruleForm.validate((valide) => {
            if(valide){
                if(this.type === 1){
                    this.addFaceFunc()
                }else{
                    this.shiBieFunc()
                }
            }
        })
    //   this.$http.post("/face/"+(this.addAndUpdateState?'save':'update'),this.faceObj)
    },
    shiBieFunc(){
        this.$http.post('/api/facebody/searchFace',{
            file: this.faceObj.faceBase
        }).then(res => {
        console.log(res, 'searchFace')
            if(res){
                this.$emit('success')
            }else{
                this.$emit('error')
            }
        }).catch(e => {
            Message.error(e.message||e.msg)
        })
    },
    addFaceFunc(){
        this.$http.post('/api/facebody/createFaceData',{
            file: this.faceObj.faceBase
        }).then(res => {
            console.log(res, 'res')
            if(res){
                Message.success('人脸录入成功')
                axios.get(`/api/user/getUser?token=${localStorage.getItem('rsw_token')}`).then(res => {
                  if(res && res.data && res.data.data && res.data.data.id){
                      this.$store.commit('CHANGE_STATE',{userInfo:res.data.data});
                  }
                })
                this.$emit('close')
            }
        }).catch(e => {
            Message.error(e.message||e.msg)
        })
    },
    // 录入
    enteringFace(){
      this.faceObj.faceBase = $camera.draw(this.faceOption)
      let faceBase = document.getElementById("faceBase");
      faceBase.innerHTML = "<img src='"+this.faceObj.faceBase+"' />"
    },
    // 关闭弹出层
    handleClose() {
      this.$emit('close')
    },
    // 设置按钮的延迟加载
    setCameraState(){
      setTimeout(()=>{
        this.cameraState = true
      },1500)
    },
     startVideoFunc(){
        this.faceOption = $camera.getCamera({
            videoWidth: 200,
            videoHeight: 200,
            thisCancas: null,
            thisContext: null,
            thisVideo: null,
            canvasId:'canvasCamera2',
            videoId:'videoCamera2'
        });
     }
   }
};
</script>
<style lang='scss' scoped>
.page-row{
    margin-top: 20px;
    text-align: center;
}
.savevideoCamera-canvasCamera{
    position: relative;
    width: 200px;
    height: 200px;
}
.saveface-special-effects,.saveface-special-effects-2{
    width:  300px;
    height: 300px;
    position: absolute;
    z-index: 99999999999!important;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 0;
    margin-left: 100px;
}
.saveface-special-effects{
    background: url(../assets/face.gif) no-repeat;
    background-size: 300px 300px;
}
.saveface-special-effects-2{
    background: url(../assets/face_detection.gif) no-repeat;
    background-size: 300px 300px;
}
.saveface-btn{
    width: 100%;
    height: 50px;
    z-index: 999999999999!important;
    margin-top: 45px;
    text-align: left;
}
.saveface-btn button{
    background-color: #ffffff;
    border: 1px solid #dcdfe6;
    width: 200px;
    height: 40px;
    color: #333333;
    cursor: pointer;
}

.savefaceBase{
    width:  200px;
    height: 200px;
    position: absolute;
    z-index: 99999999999!important;
    transform: translate(-50%,-50%);
    top: 34%;
    left: 75%;
    border: 1px solid #dcdfe6;
}
.savefaceBase img{
    width: 100%;
    height: 100%;
}
</style>